import { __extends } from "tslib";
import { FaqItem } from '../models/faq-item';
import { FaqSpotBaseController } from '../models/faq-spot-base.controller';
var relatedFaqShowLimit = 5;
var RelatedFaqsSpotController = (function (_super) {
    __extends(RelatedFaqsSpotController, _super);
    function RelatedFaqsSpotController($scope, productContextService, siteLanguage) {
        return _super.call(this, $scope, productContextService, siteLanguage) || this;
    }
    RelatedFaqsSpotController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
        this.$scope.initialLimit = relatedFaqShowLimit;
        this.$scope.limit = relatedFaqShowLimit;
        this.$scope.$on('related-faqs', this.onRelatedFaq.bind(this));
    };
    RelatedFaqsSpotController.prototype.onRelatedFaq = function (event, faqItems) {
        if (faqItems === void 0) { faqItems = []; }
        this.$scope.faqItems = faqItems.map(function (x) { return new FaqItem(x); });
        this.$scope.initialFaqItems = this.$scope.faqItems.slice();
        this.showMoreAvailable = this.$scope.faqItems.length > this.$scope.limit;
    };
    RelatedFaqsSpotController.$inject = [
        '$scope',
        'productContextService',
        'siteLanguage',
    ];
    return RelatedFaqsSpotController;
}(FaqSpotBaseController));
export { RelatedFaqsSpotController };
